import React, { Component } from 'react';
import {withStyles} from '@material-ui/core/styles'
import classNames from 'classnames';
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Input from '@material-ui/core/Input'
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Card from '@material-ui/core/Card'
import { auth } from '../../../firebase';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const INITIAL_STATE = {
  passwordOne: '',
  passwordTwo: '',
  error: null,
  showPassword: false,
};

const styles = theme =>({
  margin: {
    margin: theme.spacing.unit,
  },
  withoutLabel: {
    marginTop: theme.spacing.unit * 3,
  },
  textField: {
    flexBasis: 200,
  },
  card: {
    marginBottom: theme.spacing.unit*1,
    padding: 8,
    border: '2px solid' + theme.palette.primary.light
  },
  lable: {
    fontSize: '0.7422em',
    fontWeight: 'bold'
  },
})

class PasswordChangeForm extends Component {
  constructor(props) {
    super(props);

    this.state = { ...INITIAL_STATE };
  }

  onSubmit = (event) => {
    const { passwordOne } = this.state;

    auth.doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });

    event.preventDefault();
  }

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !state.showPassword }));
  };

  renderPasswordInput = (inputValue, inputType) =>{
    const {classes} = this.props
    return (
      <FormControl className={classNames(classes.margin, classes.textField)}>
        <InputLabel htmlFor="adornment-password">
          {inputType==='passwordOne'
            ? "Neues Kennwort"
            : "Kennwort wiederholen"}
        </InputLabel>
        <Input
          type={this.state.showPassword ? 'text' : 'password'}
          value={inputValue}
          onChange={event => this.setState(byPropKey(inputType, event.target.value))}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="Toggle password visibility"
                onClick={this.handleClickShowPassword}
              >
                {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    )
  }

  renderResetButton = (classes, isInvalid) =>
  	<Button 
      variant="contained"
      color="primary"
      className={classes.button}
      disabled={isInvalid}
      type='submit'
      size='small'
    >
      Kennwort Zurücksezten
    </Button>
  
  render() {

    const {
      passwordOne,
      passwordTwo,
      error,
    } = this.state;
    const {classes} = this.props

    const isInvalid =
      passwordOne !== passwordTwo ||
      passwordOne === '';
    return (
      <Card className={classes.card}>
          <Typography className={classes.lable} variant='button'>Kennwort ändern</Typography>
        <form onSubmit={this.onSubmit}>
            {this.renderPasswordInput(passwordOne, 'passwordOne')}
            {this.renderPasswordInput(passwordTwo, 'passwordTwo')}
            {this.renderResetButton(classes, isInvalid)}
            { error && <p style={{color: 'red'}}>{error.message}</p> }
        </form>
      </Card>
    );
  }
}



export default withStyles(styles)(PasswordChangeForm);


// WEBPACK FOOTER //
// ./src/Components/UserAuth/UserAccount/PasswordChange.js